/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/call-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 460,
        padding: 0
    },
    columnWidth: {
        callId: 70,
        callDateAndTime: 90,
        duration: 80,
        callCallerType: 100,
        caller: 90,
        resolution: 90,
        
        // special columns
        _groupActions: 70, // group actions column
    },
    filterFlyoutWidths: {
        callCallerType: 200,
        resolution: 180,
        categoryAndReason: 300,
    },
    valueColors: {
        resolution: {
            resolved: '#59ad00',
            unresolved: '#e7aa00',
        },
    },
    actionIcons: {},
};
